import Vue from 'vue';
import App from './App.vue';
import AppMfe from './AppMfe.vue';
import router from './router';
import mfeRouter from './mfe_router';
import store from './store/index';
import { VuePlugin } from 'vuera';
import VueAnalytics from 'vue-analytics';
import axios from 'axios';
import './styles/main.scss';
import { EnvironmentProviderPlugin, Environment } from './plugins/environmentProviderPlugin';

import { centralizedAuth } from '@cimpress/simple-auth-wrapper';
import AuthConfig from './lib/authConfig';
import AuthManager from './lib/authManager';
import UserManager from './lib/userManager';

import { commands } from './lib/vueAnalyticsCommands';

class MainAppFactory {
  createApp() {
    return App;
  }
  createRouter() {
    return router;
  }
}

class MfeAppFactory {
  createApp() {
    return AppMfe;
  }
  createRouter() {
    return mfeRouter;
  }
}

const getFactory = layout => {
  if (layout === 'microfrontend') {
    return new MfeAppFactory();
  }
  return new MainAppFactory();
};

Vue.config.productionTip = false;
Vue.use(VuePlugin);
Vue.use(EnvironmentProviderPlugin);
Vue.use(VueAnalytics, {
  id: 'UA-154580495-1',
  router,
  debug: {
    enabled: Environment.getEnvironment() !== 'production', // whether console statements are written
    sendHitTask: Environment.getEnvironment() === 'production' // whether the hits are sent to GA
  },
  commands
});

const baseURL = 'https://api.data-discovery.cimpress.io';

const logger = {
  // eslint-disable-next-line no-console
  log: console.log
};

let userManager = new UserManager();
let authConfig = new AuthConfig();
let authWrapper = new centralizedAuth({
  clientID: authConfig.clientId,
  redirectRoute: '/'
});
authWrapper.on('tokenExpired', async () => {
  const nextUri = window.location.pathname || '/';
  await authWrapper.login({ nextUri, forceLogin: true });
});

/**
 *
 * @param {string|HTMLElement} targetElement - The ID of the DOM element or the DOM element itself to mount the Vue app to. Defaults to 'app'.
 */
async function initializeVueApp(targetElement = 'app', layout = 'standalone') {
  const factory = getFactory(layout);
  let authManager = new AuthManager(userManager, authWrapper, logger);
  await authManager.login();
  // Setting axios timeout(ms) which occurs when server takes long time to respond
  axios.defaults.timeout = 90000;
  const platformClient = axios.create({ baseURL });
  platformClient.interceptors.request.use(config => {
    const token = authManager.getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
  const metadataPlatformClient = axios.create({ baseURL: process.env.VUE_APP_AMUNDSEN_META_URL, headers: { 'X-Requested-From': 'ui' } });
  metadataPlatformClient.interceptors.request.use(config => {
    const token = authManager.getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  new Vue({
    router: factory.createRouter(),
    store,
    provide: {
      authManager,
      userManager,
      platformClient,
      metadataPlatformClient
    },
    render: h => h(factory.createApp())
  }).$mount(targetElement instanceof HTMLElement ? targetElement : `#${targetElement}`);
}

export { initializeVueApp };
